import { render, staticRenderFns } from "./AdminCategoryImageAddModal.vue?vue&type=template&id=5cd35e45"
import script from "./AdminCategoryImageAddModal.vue?vue&type=script&lang=js"
export * from "./AdminCategoryImageAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cd35e45')) {
      api.createRecord('5cd35e45', component.options)
    } else {
      api.reload('5cd35e45', component.options)
    }
    module.hot.accept("./AdminCategoryImageAddModal.vue?vue&type=template&id=5cd35e45", function () {
      api.rerender('5cd35e45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminCategoryImageAddModal.vue"
export default component.exports